import React, { useState } from "react";
import { AuthLayout } from "./auth-layout.component";
import { Button } from "../../../../dentlab/src/components/ui/button";
import { Input } from "../../../../dentlab/src/components/ui/input";
import { Label } from "../../../../dentlab/src/components/ui/label";
import { Link } from "react-router-dom";

export const TechnicianSignIn: React.FC<{
	onSubmit: (event: React.FormEvent<HTMLFormElement>) => Promise<void>;
}> = ({ onSubmit }) => {
	const [loading, setLoading] = useState(false);
	const formRef = React.useRef<HTMLFormElement>(null);

	const handleDevLogin = (email: string, password: string) => {
		if (!formRef.current) return;
		const emailInput = formRef.current.querySelector<HTMLInputElement>('[name="email"]');
		const passwordInput = formRef.current.querySelector<HTMLInputElement>('[name="password"]');
		if (emailInput && passwordInput) {
			emailInput.value = email;
			passwordInput.value = password;
			formRef.current.requestSubmit();
		}
	};

	return (
		<AuthLayout
			title="Willkommen zurück!"
			subtitle="Melden Sie sich mit Ihren dentLAB-Daten an."
		>
			<form
				ref={formRef}
				onSubmit={(e) => {
					setLoading(true);
					onSubmit(e).then(() => {
						setLoading(false);
					});
				}}
				noValidate
				className="space-y-4"
			>
				<div className="space-y-2">
					<Label htmlFor="email">E-Mail</Label>
					<Input
						id="email"
						name="email"
						type="email"
						autoComplete="email"
						required
						autoFocus
						className="h-12"
						aria-label="E-Mail Adresse"
						data-testid="login-email-input"
					/>
				</div>
				<div className="space-y-2">
					<Label htmlFor="password">Passwort</Label>
					<Input
						id="password"
						name="password"
						type="password"
						autoComplete="current-password"
						required
						className="h-12"
						aria-label="Passwort"
						data-testid="login-password-input"
					/>
				</div>
				<Button
					type="submit"
					size="lg"
					className="w-full h-12 text-base"
					disabled={loading}
					aria-label="Anmelden"
					data-testid="login-submit-button"
				>
					{loading ? "Wird geladen..." : "Anmelden"}
				</Button>
				{import.meta.env.DEV && (
					<div className="flex flex-wrap gap-2 pt-2" data-testid="dev-autofill">
						<button type="button" onClick={() => handleDevLogin('test@dentdesk.ch', 'Test1234!')} className="rounded bg-gray-100 px-2 py-1 text-xs text-gray-600 hover:bg-gray-200">Lab Admin</button>
						<button type="button" onClick={() => handleDevLogin('anna@dentdesk.ch', 'Test1234!')} className="rounded bg-gray-100 px-2 py-1 text-xs text-gray-600 hover:bg-gray-200">Techniker (Anna)</button>
						<button type="button" onClick={() => handleDevLogin('marco@dentdesk.ch', 'Test1234!')} className="rounded bg-gray-100 px-2 py-1 text-xs text-gray-600 hover:bg-gray-200">Techniker (Marco)</button>
						<button type="button" onClick={() => handleDevLogin('courier@dentdesk.ch', 'Test1234!')} className="rounded bg-gray-100 px-2 py-1 text-xs text-gray-600 hover:bg-gray-200">Kurier (Luca)</button>
						<button type="button" onClick={() => handleDevLogin('cadcam@dentdesk.ch', 'Test1234!')} className="rounded bg-gray-100 px-2 py-1 text-xs text-gray-600 hover:bg-gray-200">Fremdlabor (Klaus)</button>
						<button type="button" onClick={() => handleDevLogin('migration@dentdesk.ch', 'Migration123')} className="rounded bg-amber-100 px-2 py-1 text-xs text-amber-700 hover:bg-amber-200">Migration</button>
					</div>
				)}
			</form>

			<div className="mt-4 space-y-3 text-center">
				<Link
					to="/password-recovery"
					className="block text-sm text-gray-600 hover:text-gray-900 hover:underline"
				>
					Passwort vergessen?
				</Link>
				<Link
					to="/registrierung"
					className="block text-sm font-medium text-gray-900 hover:underline"
					data-testid="signup-link"
				>
					Noch kein Account? Jetzt registrieren
				</Link>
				<Link
					to="/kommunikation-login"
					className="block text-sm text-gray-600 hover:text-gray-900 hover:underline"
					data-testid="vendor-signin-link"
					aria-label="Zum Kommunikations-Login wechseln"
				>
					Kommunikations-Login (Einmalpasswort)
				</Link>
			</div>

			<a
				href={import.meta.env.VITE_DENTCONNECT_URL}
				rel="noopener noreferrer"
				className="absolute top-4 right-4 text-sm text-gray-600 hover:text-gray-900 hover:underline"
			>
				Ich bin Zahnarzt
			</a>
		</AuthLayout>
	);
};
